import { Component, OnInit, ViewChild } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import { AjaxService } from '../../../service/ajax.service';
import { UtilService } from '../../../service/util.service';
import { API } from '../../../../environments/environment';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-minha-agenda',
  templateUrl: './minha-agenda.component.html',
  styleUrls: ['./minha-agenda.component.scss']
})
export class MinhaAgendaComponent implements OnInit {
  @ViewChild('calendar', { static: false }) calendarComponent: FullCalendarComponent;

  calendarVisible = true;
  calendarPlugins = [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin];
  calendarWeekends = true;
  locale = ptBrLocale;
  loading = false;
  calendarEvents: EventInput[] = [];

  constructor(
    private ajaxService: AjaxService,
    private util: UtilService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    const hoje = new Date();
    this.carregarAgenda(hoje.getMonth() + 1, hoje.getFullYear());
  }

  handleDateClick(arg: any): void {
    if (!arg) return;
  }

  handleDatesRender(arg: any): void {
    const dataBase: Date = arg?.view?.currentStart || new Date();
    this.carregarAgenda(dataBase.getMonth() + 1, dataBase.getFullYear());
  }

  private carregarAgenda(mes: number, ano: number): void {
    const idUsuarioLogado = this.getIdUsuarioLogado();
    if (!idUsuarioLogado) {
      this.calendarEvents = [];
      this.util.toasterShowError('Erro', 'Usuário logado não identificado para carregar agenda.');
      return;
    }

    const payload = { mes, ano, idUsuarioLogado };
    const url = API + 'empresa/AgendaClinica/GetDadosAgenda';

    this.loading = true;
    this.util.showLoading();

    this.ajaxService.post(url, payload).subscribe({
      next: (response) => {
        this.loading = false;
        this.util.closeLoading();

        const lista = response?.data && Array.isArray(response.data) ? response.data : [];
        this.calendarEvents = lista
          .map((item: any) => this.util.converterParaLowercase(item))
          .filter((item: any) => item && item.data)
          .map((item: any) => this.mapearEvento(item));
      },
      error: () => {
        this.loading = false;
        this.util.closeLoading();
        this.calendarEvents = [];
        this.util.toasterShowError('Erro', 'Erro ao carregar agenda');
      }
    });
  }

  private getIdUsuarioLogado(): number | null {
    const userData = this.userService.getUserData();
    if (!userData) return null;

    const userId =
      Number(userData.User?.Id) ||
      Number((userData as any)?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid']) ||
      0;

    return userId > 0 ? userId : null;
  }

  private mapearEvento(item: any): EventInput {
    const status = (item.status || '').toLowerCase();
    const situacao = (item.situacao || '').toLowerCase();
    let cor = '#04a9f5';

    if (status === 'confirmado') cor = '#28a745';
    else if (status === 'a confirmar') cor = '#ffc107';
    else if (status === 'cancelado') cor = '#dc3545';
    else if (situacao === 'finalizado') cor = '#6c757d';

    const tituloBase = item.nomepaciente || 'Atendimento';
    const tipo = item.tipo ? ` - ${item.tipo}` : '';

    return {
      title: `${tituloBase}${tipo}`,
      start: item.data,
      end: item.datafim || item.data,
      borderColor: cor,
      backgroundColor: cor,
      textColor: '#fff'
    };
  }
}